import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getLanguagesLookups } from './thunks';
import { LanguagesState } from './types';

export const name = 'languages';

const initialState: LanguagesState = {
  lookups: {
    data: [],
    status: 'idle',
  },
};

export const getLanguagesLookupsAsync = createAsyncThunk(
  name + '/getLanguagesLookups',
  getLanguagesLookups
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLanguagesLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getLanguagesLookupsAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getLanguagesLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
